import { OMT_UI_FriendsListView } from '../../../OMT_UI/FriendsList/OMT_UI_FriendsListView';
import { GateFriendListItem } from './GateFriendListItem';

/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */

/*
  freinds list view for Window_AdFallback_AskFriends
*/
export class GateFriendListView extends OMT_UI_FriendsListView {
  /**
   * constructor
   * @param {number} itemHeight
   * @param {Phaser.Rectangle} scrollRect
   * @param {number} cooldownDuration time in milliseconds
   * @param {string} cooldownId string for saveState identifier
   */
  constructor(itemHeight, scrollRect, cooldownDuration, cooldownId) {
    super();

    this.signals.onClick = new Phaser.Signal();

    this._cooldownDuration = cooldownDuration;
    this._cooldownId = cooldownId;
    this.init(itemHeight, scrollRect, G.OMTsettings.adFallback_AskFriend.graphics.oddColourBg, G.OMTsettings.adFallback_AskFriend.graphics.evenColourBg);
  }

  /**
   * create friendList item
   * @param {Object} friendData
   * @param {number} itemWidth
   * @param {number} itemHeight
   * @param {number} bgColor
   */
  _createFriendListItem(friendData, itemWidth, itemHeight, bgColor) {
    const listItem = new GateFriendListItem(friendData, itemWidth, itemHeight, bgColor, this._cooldownDuration, this._cooldownId);
    listItem.signals.onClick.add(this.onClick.bind(this));
    return listItem;
  }

  /**
   * called when a child item 'ask' is clicked
   * @param {Object} item
   */
  onClick(item) {
    this.signals.onClick.dispatch(item);
  }

  /**
   * disable interactivity
   */
  disable() {
    this._scrollArea.disable();
  }

  /**
   * enable interactivity
   */
  enable() {
    this._scrollArea.enable();
  }
}
